import { render } from "./LoaderAnimation.vue?vue&type=template&id=e9c81750&scoped=true"
const script = {}

import "./LoaderAnimation.vue?vue&type=style&index=0&id=e9c81750&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e9c81750"]])

export default __exports__